import _ from 'lodash';

const createLoadingSelector = actions => state => _(actions).some(action => _.get(state, action));
export default createLoadingSelector;
